import { ICreditCard, TripUserPaymentMethod } from "@cruisen/contract"
import { prettyCardNumber } from "@cruisen/react-shared"
import { TDataGridItem } from "../components/organisms/BookingModal/components/DataGrid"

export const usePaymentData = ({
  isPaymentMethodsLoading,
  selectedPaymentMethod,
  isPaymentMethodRevealing,
}: {
  isPaymentMethodsLoading: boolean
  selectedPaymentMethod: TripUserPaymentMethod
  isPaymentMethodRevealing: boolean
}) => {
  let creditCardData: Pick<
    ICreditCard,
    "cardNumber" | "cardholderName" | "expiryMonth" | "expiryYear" | "signature"
  > = {
    cardNumber: "",
    cardholderName: "",
    expiryMonth: "",
    expiryYear: "",
    signature: "",
  }
  const tokenizedCreditCard = selectedPaymentMethod?.tokenizedCreditCard

  if (selectedPaymentMethod?.creditCard) {
    creditCardData = {
      ...selectedPaymentMethod.creditCard,
      cardNumber: prettyCardNumber(
        selectedPaymentMethod.creditCard.cardNumber.toString(),
        tokenizedCreditCard.brandId,
      ),
    }
  } else if (tokenizedCreditCard) {
    creditCardData = {
      cardNumber: `Ending in ${tokenizedCreditCard.cardLast4}`,
      cardholderName: tokenizedCreditCard.cardholderName,
      expiryMonth: tokenizedCreditCard.expiryMonth.toString(),
      expiryYear: tokenizedCreditCard.expiryYear.toString(),
      signature: tokenizedCreditCard.signatureExpired ? "" : "•••",
    }
  }

  const paymentData: TDataGridItem[] = [
    {
      label: "Cardholder name",
      value: creditCardData.cardholderName?.toString() ?? "-",
    },
    {
      label: "Card number",
      value: isPaymentMethodRevealing
        ? "%skeleton%"
        : (creditCardData.cardNumber?.toString() ?? "-"),
      copyDisabled: !selectedPaymentMethod?.creditCard?.cardNumber,
      copyValue: creditCardData.cardNumber?.toString(),
    },
    {
      label: "Expiration date",
      value: creditCardData.expiryMonth
        ? `${creditCardData.expiryMonth.toString().padStart(2, "0")}/${creditCardData.expiryYear}`
        : "-",
    },
    {
      label: "CVC",
      value: isPaymentMethodRevealing ? "%skeleton%" : (creditCardData.signature?.toString() ?? ""),
      copyDisabled: !selectedPaymentMethod?.creditCard?.signature,
    },
  ].map((item) => {
    if (isPaymentMethodsLoading) {
      return {
        ...item,
        value: "%skeleton%",
      }
    }
    return item
  })

  return {
    paymentData,
  }
}
